'use strict';

/**
 * Overview for the sets
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var BaseLayout = require('./base');
var ListControlView = require('../partials/list-control');
var DropControlView = require('../partials/drop-control');
var ListViewFactory = require('modules/collection/views/partials/list-factory');
var FilterModalView = require('../partials/filter-modal');

var template = require('modules/collection/templates/layout/list.hbs');

var ListLayout = BaseLayout.extend({
    template: template,

    regions: {
        objectsRegion: '.objects-list-region',
        controlsRegion: '.listcontrol-region',
        listHeaderRegion: '.list-header-region',
        detailHeaderRegion: '.detail-header-region',
        dropControlRegion: '.drop-control-region',
    },

    ui: {
        scrollContainer: '.list-layout-scroll-container',
    },

    modelEvents: {
        'change:viewMode': 'viewModeChanged',
        'change:controlMode': 'controlModeChanged',
        'change:filterModal': 'filterModalChanged',
        'change:activeModel': 'activeModelChanged',
    },

    defaultViewOptions: {},

    showListActions: true,

    initialize: function(options) {
        BaseLayout.prototype.initialize.apply(this, arguments);

        this.defaultViewOptions = {
            model: this.model,
            collection: this.collection,
            showListActions: this.showListActions,
        };

        this.listenTo(App.vent, 'hide:extra-content', this.extraContentHidden.bind(this));
        this.listenTo(App.vent, 'show:extra-content', this.extraContentShown.bind(this));
    },

    viewModeChanged: function(model) {
        this.showListView();
    },

    controlModeChanged: function(model, controlMode) {
        if (controlMode !== 'manage') {
            this.collection.each(function(model) {
                model.set('selected', false);
            });
        }
    },

    filterModalChanged: function(model, filterModalActive) {
        if (filterModalActive) {
            var modal = this.modal = new FilterModalView({
                collection: this.collection,
                model: this.model,
                baseCollection: this.getOption('baseCollection'), //collection without filters applied (except for set id, search ids, etc.)
            });

            modal.$('[data-action="close"]').focus();
        }
    },

    getHeaderViewClass: function () {
        throw('ListLayout cannot be instantiated directly, provide header implementation in subclass');
    },

    onBeforeShow: function(view, region) {
        this.controlsRegion.show(new ListControlView(_.extend({
            scrollContainer: this.ui.scrollContainer,
            viewSwitch: true,
        }, this.defaultViewOptions)));

        var HeaderViewClass = this.getHeaderViewClass();
        this.listHeaderRegion.show(new HeaderViewClass(_.extend({
            search: true,
            editable: true,
            shareable: true,
            showroomOptions: true,
            viewSwitch: false,
        }, this.defaultViewOptions)));

        this.detailHeaderRegion.show(new HeaderViewClass(_.extend({
            viewSwitch: true,
            viewSwitchDetail: true,
            backLink: true,
        }, this.defaultViewOptions)));

        this.activeModelChanged(this.model, this.model.get('activeModel'));

        this.dropControlRegion.show(new DropControlView(this.defaultViewOptions));

        this.showListView();
    },

    showListView: function() {
        var listViewOptions = _.extend({
            lazyRender: true,
            lazyRenderScrollEl: this.ui.scrollContainer,

            // @todo: Derive previous page threshold from header height
            lazyRenderPreviousPageThreshold: 250,

            scrollContainer: this.ui.scrollContainer,
            activeChildModel: this.model.get('activeModel'),
        }, this.defaultViewOptions);

        if (_.isFunction(this.getEmptyViewClass)) {
            listViewOptions.emptyView = this.getEmptyViewClass();
        }

        var listViewFactory = new ListViewFactory();
        var listViewType = this.model.get('viewMode');

        var listView = listViewFactory.createListView(listViewType, listViewOptions);

        this.objectsRegion.show(listView);
    },

    /**
     * Unhides detail header as soon as transition to detail view begins.
     * Unhides list header as soon as transition to list view begins.
     */
    activeModelChanged: function (model, activeModel) {
        if (activeModel) {
            this.detailHeaderRegion.$el.css('visibility', 'visible');
            this.hideListHeader = true;
        } else {
            this.detailHeaderRegion.$el.css('visibility', 'hidden');
            this.listHeaderRegion.$el.css('visibility', 'visible');
            this.headerFixStart();
        }
    },

    /**
     * Hides detail header when extra-content transition has finished.
     */
    extraContentHidden: function() {
        if (this.detailHeaderRegion.$el.length) {
            this.detailHeaderRegion.$el.css('visibility', 'hidden');
        }
        this.headerFixEnd();
    },

    headerFixStart: function(){
        // translate3d(0, 0, 0) causes new origin.position for position:fixed
        // this fixes this
        if ($('body').hasClass('is-detail-mode')) {
            this.controlsRegion.$el.find('.listcontrol').css('margin-left', '-18rem');
            this.detailHeaderRegion.$el.css('visibility', 'hidden');
        }
    },
    headerFixEnd: function(){
        this.controlsRegion.$el.find('.listcontrol').css('margin-left', '');
    },

    /**
     * Hides list header when extra-content transition has finished.
     */
    extraContentShown: function() {
        if (this.hideListHeader && this.listHeaderRegion.$el.length) {
            delete this.hideListHeader;
            this.listHeaderRegion.$el.css('visibility', 'hidden');
        }
    },
});

module.exports = ListLayout;